import { z } from "zod";
// XI canonical business domains. Single source of truth — must mirror
// XTS/src/config/domains.ts. Companies are modelled across exactly these 6
// domains regardless of industry; PlayStudio scopes Inbox + Plays + memberships
// to a domain and surfaces a domain switcher in the topbar.
export const XI_DOMAINS = [
    "people",
    "process",
    "market_and_brand",
    "tech",
    "finance",
    "offer",
];
export const DomainSchema = z.enum(XI_DOMAINS);
export const DOMAIN_LABELS = {
    people: "People & Capability",
    process: "Process & Operations",
    market_and_brand: "Market & Brand",
    tech: "Technology",
    finance: "Finance",
    offer: "Offer",
};
// Map XTS roadmap_initiatives.initiative_type → canonical XI domain. Mirrors
// the inverse of XTS/src/services/xi-engine/strategy-output.ts:488-494. Used
// when projecting federated XTS initiatives into PlayStudio roadmap_entries.
//
// Software is intentionally NOT mapped — software initiatives route to the
// Software Factory (XDD), not PlayStudio, and should be filtered out at the
// federated read layer before this mapping is consulted.
export function domainForInitiativeType(initiativeType) {
    if (!initiativeType)
        return null;
    switch (initiativeType.toLowerCase()) {
        case "gtm":
            return "market_and_brand";
        case "process":
        case "operational":
        case "vendor":
            return "process";
        case "org_design":
        case "recruitment":
        case "training":
        case "capability":
            return "people";
        case "offer":
        case "product":
        case "service":
        case "offering":
            return "offer";
        case "finance":
        case "financial":
            return "finance";
        case "tech":
        case "technology":
            return "tech";
        case "software":
            return null; // routes to Software Factory, not PlayStudio
        default:
            return null;
    }
}
// Map XTS business_objectives.dimension → canonical XI domain. XTS uses legacy
// and variant spellings (e.g. "technology", "financial", "operations") that
// differ from the XI canonical slugs. Preferred over domainForInitiativeType
// when available, since the objective dimension is the authoritative source.
export function domainForObjectiveDimension(dimension) {
    if (!dimension)
        return null;
    switch (dimension.toLowerCase()) {
        case "finance":
        case "financial":
        case "risk": // Risk objectives are Finance-adjacent in XTS legacy data
            return "finance";
        case "people":
        case "hr":
        case "human_resources":
        case "talent":
            return "people";
        case "tech":
        case "technology":
        case "digital":
            return "tech";
        case "market_and_brand":
        case "marketing":
        case "brand":
        case "gtm":
        case "growth":
            return "market_and_brand";
        case "process":
        case "operations":
        case "operational":
        case "supply_chain":
            return "process";
        case "offer":
        case "product":
        case "service":
        case "offering":
            return "offer";
        default:
            return null;
    }
}
